export const environment = {
  production: true,
  appBaseUrl: 'https://ferreira-auto.com.br/#/',
  apiBasePath: '/api',
  apiBaseUrl: 'https://auto-1-k9gu.onrender.com'
};